import { useLocation, useParams } from 'react-router';

import { catchAll } from '@sorare/routing';
import {
  ANY_SPORT_PLAY_BOARDS_ARENA,
  ANY_SPORT_PLAY_BOARDS_PRO,
} from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import { Mode, arenaModeToMode } from '#src/lib/gameMode.ts';

export const useCurrentBoardMode = (): Mode => {
  const { pathname } = useLocation();
  const { arenaMode } = useParams();
  const { matchAnySportPath } = useSportContext();

  if (matchAnySportPath(catchAll(ANY_SPORT_PLAY_BOARDS_PRO), pathname)) {
    return Mode.PRO;
  }

  if (matchAnySportPath(catchAll(ANY_SPORT_PLAY_BOARDS_ARENA), pathname)) {
    return arenaModeToMode(arenaMode ?? '');
  }

  return Mode.ARENA_IN_SEASON;
};
